import { render, staticRenderFns } from "./VxList.vue?vue&type=template&id=2587409e"
import script from "./VxList.vue?vue&type=script&lang=js"
export * from "./VxList.vue?vue&type=script&lang=js"
import style0 from "./VxList.vue?vue&type=style&index=0&id=2587409e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports